import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {DatePipe} from "@angular/common";
import {ModalDirective} from "ngx-bootstrap/modal";
import {Component, OnDestroy, ViewChild, OnInit, ElementRef, ChangeDetectorRef} from "@angular/core";
import {TrackService} from "../../services/track.service";
import {TrackrespModel} from "../../models/trackresp.model";
import {TrackreqModel} from "../../models/trackreq.model";
import {LangService} from "../../../shared/services/lang.service";
import {PassportData} from "../../models/PassportData.model";

@Component({
  selector: 'app-track',
  templateUrl: './tracking-pass.component.html',
  styleUrls: ['./tracking-pass.component.css']
})
export class TrackingPassComponent implements OnInit, OnDestroy {

  @ViewChild('errorModal', {static: true}) errorModal: ModalDirective;
  @ViewChild('resultSection') resultSection!: ElementRef;

  show: Boolean = false;
  form: FormGroup;
  subscription: Subscription;
  spinner: Boolean = false;
  trackResp: TrackrespModel<PassportData> = null;
  error: any;

  constructor(private router: Router,
              private fb: FormBuilder,
              private datePipe: DatePipe,
              private langService: LangService,
              private trackService: TrackService,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      nom: ['', Validators.required],
      dateNaissance: ['', Validators.required],
      numCarteConsulaire: ['', Validators.required],
      numPersonnel: ['', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{15}$/)
      ]]
    });
    this.route.queryParams.subscribe(params => {
      this.form.patchValue({
        nom: params['lastName'] ?? '',
        numCarteConsulaire: params['cid'] ?? '',
        dateNaissance: params['birthDay'] ?? ''
      });
    });
  }

  onRedirectlogin() {
    window.open('/account', '_self');
  }

  onRedirectHome() {
    this.router.navigateByUrl('home');
  }

  onSubmit(): void {
    this.spinner = true;
    const newPerson: TrackreqModel = {
      uid: this.form.value.numPersonnel,
      cid: this.form.value.numCarteConsulaire,
      birthDay: this.datePipe.transform(this.form.value.dateNaissance, 'dd/MM/yyyy'),
      lastName: this.form.value.nom
    };
    this.subscription = this.trackService.track(newPerson).subscribe(
      (resp: TrackrespModel<PassportData>) => {
        this.trackResp = resp;
        this.spinner = false;
        if (this.trackResp?.data) {
          // Cas normal → afficher stepper + scroll
          setTimeout(() => {
            this.scrollToBottom();
          }, 0);
          }
        if (this.trackResp.data == null && this.trackResp.errorCode === 409) {
          this.error = "409_ERROR";
          this.showModal();
        } else {
          throw new Error("une erreur inconue est survenue => ");
        }
      },
      (error) => {
        alert("Une erreur inconnue est survenue ! " + error);
        this.spinner = false;
        this.error = "500_ERROR";
        this.showModal();
      },
      () => {
        this.spinner = false;
      });
  }

  scrollToBottom(): void {
    this.resultSection?.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  showModal(): void {
    this.errorModal.show();
  }

  hideModal() {
    this.errorModal.hide();
  }

  ngOnDestroy(): void {
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
  }
}

